import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import { devConfig, profile } from 'config/config'; // Importing configuration settings
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the filter view for withdrawal requests.
 */
export default class FilterWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text', // Text input for date selection
                            name: 'Datepicker',
                            id: 'Datepicker',
                            css: 'reportrange',
                            readonly: true,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                        },
                        {
                            view: 'datepicker', // Datepicker component
                            name: 'Date',
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            minWidth: 200,
                            localId: 'bonusStates:combo',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Localized placeholder
                            options: [
                                // Options for the dropdown
                                {
                                    id: '',
                                    value: _('Todos'),
                                },
                                {
                                    id: 'A',
                                    value: _('Activo'),
                                },
                                {
                                    id: 'I',
                                    value: _('Inactivo'),
                                },
                                {
                                    id: 'R',
                                    value: _('Rechazado'),
                                },
                                {
                                    id: 'P',
                                    value: _('Pendiente'),
                                },
                                {
                                    id: 'E',
                                    value: _('Eliminado'),
                                },
                            ],
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            cols: [
                                {
                                    view: 'checkbox', // Checkbox for filtering by withdrawal date
                                    label: _('Por fecha de retiro pagado'), // Localized label
                                    labelPosition: 'top',
                                    name: 'ByAllowDate',
                                    value: 0,
                                    minWidth: 200,
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            id: 'upper_section',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav1', gravity: 4 }, // Spacer
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Localized label
                            width: screen == 'small' ? 0 : 130,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Localized label
                            hotkey: 'enter', // Shortcut key
                            width: screen == 'small' ? 0 : 130,
                            minWidth: 200,
                            type: 'form',
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if typeDate is not 2
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                                    }
                                }
                                this.app.callEvent('withdrawalReport:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the filter section
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            margin: 10,
            cols: [
                {
                    view: 'button', // Clear button for second form
                    value: _('Limpiar'), // Localized label
                    width: 100,
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('Datepicker').setValue(''); // Clear Datepicker value
                    },
                },
                {
                    view: 'button', // Consult button for second form
                    value: _('Consultar'), // Localized label
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 110,
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get values from second form
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('withdrawalReport:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Localized header
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            padding: 10,
            rows: [upper_section, buttons2], // Upper section and second set of buttons
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3],
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form', // Main form view
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 }, // Placeholder for small screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if condition is true
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
